"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = BasePlan;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native");
var _moment = _interopRequireDefault(require("moment"));
require("moment/locale/es-us");
require("moment/locale/en-gb");
var _styles = require("@sart/styles");
var _content = require("@sart/content");
var _client = _interopRequireDefault(require("@sart/client"));
var _Text = _interopRequireDefault(require("./Text"));
var _Label = _interopRequireDefault(require("./Label"));
var _Price = _interopRequireDefault(require("./Price"));
var _Space = _interopRequireDefault(require("./Space"));
var _Anchor = _interopRequireDefault(require("./Anchor"));
var _Button = _interopRequireDefault(require("./Button"));
var _Switch = _interopRequireDefault(require("./Switch"));
var _StoredPaymentMethod = _interopRequireDefault(require("./StoredPaymentMethod"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function BasePlan(props) {
  var product = props.product,
    productContainer = props.productContainer,
    labelStyle = props.labelStyle,
    nameStyle = props.nameStyle,
    textStyle = props.textStyle,
    buttonStyle = props.buttonStyle,
    buttonTitleStyle = props.buttonTitleStyle,
    productName = props.productName,
    price = props.price,
    code = props.code,
    showChange = props.showChange,
    showToggle = props.showToggle,
    toggleValue = props.toggleValue,
    onToggle = props.onToggle,
    toggleDisabled = props.toggleDisabled,
    discounts = props.discounts;
  var content = (0, _content.useContent)();
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isEnabled = _useState2[0],
    setIsEnabled = _useState2[1];
  var toggleSwitch = function toggleSwitch() {
    return setIsEnabled(function (previousState) {
      return !previousState;
    });
  };
  var language;
  if (_client["default"].cache.language === 'en') {
    language = 'en-gb';
  } else if (_client["default"].cache.language === 'es') {
    language = 'es-us';
  }
  function getDisplayDetailsForLanguage(addOn) {
    //Get the display details for the language that is selected in the cache
    var displayDetails = undefined;

    //identify the correct display details to use based on language
    if (addOn.product.displayDetails) {
      addOn.product.displayDetails.map(function (detail) {
        if (detail.language === _client["default"].cache.language) {
          displayDetails = detail;
        }
      });
    }
    return displayDetails;
  }
  function getColourByCategory(displayDetails, category) {
    if (!category) {
      return undefined;
    }
    var toReturn = undefined;
    var hexCodeRegex = /^#(?:[0-9a-fA-F]{3}){1,2}$/;

    //get the relevant font colour based on the category
    if (displayDetails && displayDetails.colors && displayDetails.colors.length) {
      displayDetails.colors.map(function (color) {
        //we also only accept hex values, so use regex to make sure it matches the pattern
        if (color.category === category && hexCodeRegex.test(color.color)) {
          toReturn = color.color;
        } else if (color.category === category && color.color === 'transparent') {
          return undefined;
        }
      });
    }
    return toReturn;
  }
  function switchPlan() {}
  function getRecurringString() {
    var toReturn;
    // Use the frequency to work out if we use 'per' or 'every x'
    if (product.product.recurringFrequency === 1) {
      toReturn = content.product.per;
    } else if (product.product.recurringFrequency > 1) {
      toReturn = content.product.every + product.product.recurringFrequency;
    }
    //Use frequency unit to work out how often it recurs 
    if (product.product.recurringFrequencyUnit.toUpperCase() === 'DAYS') {
      toReturn = toReturn + content.product.days;
    } else if (product.product.recurringFrequencyUnit.toUpperCase() === 'WEEKS') {
      toReturn = toReturn + content.product.weeks;
    } else if (product.product.recurringFrequencyUnit.toUpperCase() === 'MONTHS') {
      toReturn = toReturn + content.product.months;
    }
    // If the frequency is 1, make the postfix singular
    if (product.product.recurringFrequency === 1) {
      toReturn = toReturn.substring(0, toReturn.length - 1);
    }
    return toReturn;
  }
  function formatDate(date) {
    if (date) {
      var formatted = (0, _moment["default"])(date).locale(language).format('ddd D MMM HH:mm');
      var elements = formatted.split('.').join('').split(' ');
      elements[0] = elements[0][0].toUpperCase() + elements[0].slice(1);
      elements[2] = elements[2][0].toUpperCase() + elements[2].slice(1);
      return elements.join(' ');
    }
    return null;
  }
  var displayDetails = getDisplayDetailsForLanguage(product);
  var titleColour = getColourByCategory(displayDetails, 'TitleText');
  var descriptionColour = getColourByCategory(displayDetails, 'DescriptiveText');
  var backgroundColour = getColourByCategory(displayDetails, 'Background');
  var accentColour = getColourByCategory(displayDetails, 'Accent');
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [productContainer ? productContainer : styles.container, backgroundColour ? {
      backgroundColor: backgroundColour
    } : {}]
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.row
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.column1
  }, /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: [labelStyle ? labelStyle : styles.label, descriptionColour ? {
      color: descriptionColour
    } : {}]
  }, content.product.plan), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [nameStyle ? nameStyle : styles.name, titleColour ? {
      color: titleColour
    } : {}]
  }, productName), discounts && /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 12
  }), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 12
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [nameStyle ? nameStyle : styles.name, titleColour ? {
      color: titleColour
    } : {}]
  }, "Started"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [nameStyle ? nameStyle : styles.name, titleColour ? {
      color: titleColour
    } : {}]
  }, toggleValue ? 'Renews' : 'Expires'), showToggle && [/*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 12
  }), /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: [labelStyle ? labelStyle : styles.label, descriptionColour ? {
      color: descriptionColour
    } : {}]
  }, "Auto-Renew")]), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.column2
  }, /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: [labelStyle ? labelStyle : styles.label, descriptionColour ? {
      color: descriptionColour
    } : {}]
  }, content.product.price), price !== undefined && price !== 0 && [/*#__PURE__*/_react["default"].createElement(_Price["default"], {
    style: [textStyle ? textStyle : styles.text, titleColour ? {
      color: titleColour
    } : {}],
    value: price,
    code: code
  })], discounts && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: {
      fontSize: 10
    }
  }, "*before discounts applied"), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 12
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [textStyle ? textStyle : styles.text, titleColour ? {
      color: titleColour
    } : {}]
  }, formatDate(product.startDateTime)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [textStyle ? textStyle : styles.text, titleColour ? {
      color: titleColour
    } : {}]
  }, formatDate(product.expiryDateTime)), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 12
  }), showToggle && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Switch["default"], {
    onValueChange: onToggle,
    value: toggleValue,
    disabled: toggleDisabled
    // onValueChange={(value) => handleSettingChange(setting, value)}
    ,
    trackColor: {
      "true": _styles.colors.brightOrange,
      "false": _styles.colors.trivial
    },
    ios_backgroundColor: _styles.colors.trivial,
    thumbColor: _styles.colors.white,
    style: {
      transform: [{
        scaleX: .9
      }, {
        scaleY: .9
      }]
    }
  }), toggleDisabled && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: styles.processing
  }, content.checkout.processing)), price === 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [nameStyle ? nameStyle : styles.name, titleColour ? {
      color: titleColour
    } : {}]
  }, content.common.free))), discounts && /*#__PURE__*/_react["default"].createElement(_reactNative.View, null, /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 12
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [textStyle ? textStyle : styles.text, titleColour ? {
      color: titleColour
    } : {}]
  }, "Applied Promotions"), discounts.map(function (discount, i) {
    return /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      key: "discount-".concat(i),
      style: [textStyle ? textStyle : styles.text, titleColour ? {
        color: titleColour
      } : {}]
    }, discount.code + ' - ' + discount.couponName);
  })), showChange && /*#__PURE__*/_react["default"].createElement(_reactNative.View, null, /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 24
  }), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    title: content.common.change,
    onPress: switchPlan,
    titleStyle: buttonTitleStyle,
    style: [buttonStyle, accentColour ? {
      backgroundColor: accentColour
    } : {}]
  })));
}
var styles = _reactNative.StyleSheet.create({
  container: _objectSpread({
    padding: 24,
    backgroundColor: _styles.backgroundColors.clear,
    borderRadius: _styles.radius.medium,
    elevation: 8
  }, _styles.shadows.shadowByElevation(8)),
  name: {
    fontSize: 32,
    lineHeight: 48,
    fontWeight: '700',
    color: _styles.colors.feature
  },
  row: {
    flexDirection: 'row'
  },
  column1: {
    flex: 4 / 6,
    flexDirection: 'column'
  },
  column2: {
    flex: 1 / 2,
    flexDirection: 'column'
  },
  label: {
    fontSize: 14,
    lineHeight: 24
  },
  text: {
    fontSize: 18,
    lineHeight: 24,
    color: _styles.colors.feature
  },
  cancel: {
    color: _styles.colors.trivial,
    textAlign: 'center'
  },
  processing: {
    // alignSelf: 'flex-end'
  }
});